// Данные членов команды
// Для добавления нового участника — добавьте объект в массив
export const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Роман Терушкин',
    role: 'Основатель, врач-эндокринолог',
    description:
      'Специалист в области превентивной и функциональной медицины с 10-летним опытом. Создал методику управления здоровьем на основе данных и актуальных научных исследований.',
    isFounder: true,
  },
  {
    id: 2,
    name: 'Анна Соколова',
    role: 'Нутрициолог, диетолог',
    description:
      'Эксперт по питанию и нутригеномике. Разрабатывает персонализированные программы питания на основе генетических данных и лабораторных анализов.',
    isFounder: false,
  },
  {
    id: 3,
    name: 'Дмитрий Волков',
    role: 'Спортивный врач, специалист по долголетию',
    description:
      'Исследует влияние физической активности на продолжительность и качество жизни. Разрабатывает протоколы тренировок с учётом возраста, типа телосложения и биомаркеров.',
    isFounder: false,
  },
  {
    id: 4,
    name: 'Мария Белова',
    role: 'Эндокринолог, специалист по гормонам',
    description:
      'Занимается балансировкой гормонального фона и оптимизацией метаболизма. Применяет функциональный подход к диагностике и восстановлению.',
    isFounder: false,
  },
];
